import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ImportExportIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.7072 7.70712C11.0977 7.31662 11.0977 6.68342 10.7072 6.29292L7.7071 3.29283C7.5195 3.10533 7.2652 2.99993 6.9999 2.99993C6.7347 2.99993 6.4804 3.10533 6.2928 3.29292L3.293 6.29292C2.9025 6.68353 2.9025 7.31662 3.293 7.70712C3.6836 8.09762 4.3167 8.09762 4.7072 7.70712L7 5.41422L9.293 7.70712C9.6835 8.09762 10.3167 8.09762 10.7072 7.70712Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0001 21C17.5524 21 18.0001 20.5523 18.0001 20L18.0001 4C18.0001 3.4477 17.5524 3 17.0001 3C16.4478 3 16.0001 3.4477 16.0001 4L16.0001 20C16.0001 20.5523 16.4478 21 17.0001 21Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.00007 21C7.55237 21 8.00007 20.5523 8.00007 20L8.00007 4C8.00007 3.4477 7.5522 2.99993 6.9999 2.99993C6.4476 2.99993 6.00007 3.4477 6.00007 4L6.00007 20C6.00007 20.5523 6.44777 21 7.00007 21Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.7072 16.2929C20.3166 15.9024 19.6835 15.9024 19.2929 16.2929L17.0003 18.5858L14.7072 16.2929C14.3166 15.9024 13.6835 15.9024 13.293 16.2929C12.9025 16.6835 12.9025 17.3166 13.293 17.7071L16.2932 20.7071C16.4808 20.8947 16.7349 21 17.0001 21C17.2653 21 17.5199 20.8946 17.7074 20.7071L20.7072 17.7071C21.0977 17.3165 21.0977 16.6834 20.7072 16.2929Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ImportExportIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ImportExportIcon;
